import { AxiosResponse } from "axios";
import { call } from "redux-saga/effects";
import createCustomer from "../customer/create";
import api from "../../../settings/api";

export interface Fetch {
    document: string;
    name?: string;
}

export interface CreateAccountResponse {
    data?: {
        accountIdentification: string;
    }
}

export interface StateResponse {
    data?: {
        addressStateFilter: {
            identification: string;
        }[]
    }
}

export interface CreateAccountAction {
    type: string;
    payload: Fetch;
}

interface ReturnCreateAccount extends Fetch  {
    accountId?: string;
    customerId: unknown;
}

export default function* createAccount({
    payload,
}: CreateAccountAction): Generator<ReturnType<typeof call>, ReturnCreateAccount | null, AxiosResponse<CreateAccountResponse & StateResponse>> {
    try {
        const customerId = yield call(createCustomer, {
            type: "",
            payload: {
                document: payload.document,
                name: payload?.name,
            }
        });

        if (!customerId) throw new Error();

        const response = yield call(api.post, `/v1/customers/${customerId}/accounts`, {
            isAcceptedTerms: true,
            isAcceptedPrivacy: true,
        });

        return {
            ...payload,
            customerId: customerId,
            accountId: response?.data?.data?.accountIdentification,
        }

    } catch (error) {
        return null;
    }
}